module.exports = __webpack_public_path__ + "static/media/bell.13704aea.svg";